import React, { useEffect, useState } from 'react';
import { Header, Paragraph } from 'coreComponents/design-system/typography';
import { Col, Container, Row } from 'coreComponents/design-system/flow-content';
import { Checkbox, Input, StyledButton, } from 'coreComponents/design-system/Form';
import { isEmptyObject } from 'helpers/is-empty-object';
export const CreateCustomerForm = ({ serverErrors, }) => {
    const [localData, setLocalData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        password: '',
        willSubscribe: false,
    });
    const [errors, setErrors] = useState({});
    useEffect(() => {
        if (serverErrors && !isEmptyObject(serverErrors)) {
            setErrors(serverErrors);
        }
    }, []);
    const handleChange = (field) => (value) => setLocalData(Object.assign(Object.assign({}, localData), { [field]: field === 'willSubscribe' ? Boolean(value) : value }));
    const getErrorMessage = (field) => errors[field];
    const calculateFieldState = (field) => getErrorMessage(field) ? 'error' : 'normal';
    const handleSave = e => {
        const errorMap = {};
        if (localData.firstName.length < 1) {
            errorMap['firstName'] = 'Your first name is required.';
        }
        if (localData.lastName.length < 1) {
            errorMap['lastName'] = 'Your last name is required.';
        }
        if (localData.email.length < 1) {
            errorMap['email'] = 'Your email is required.';
        }
        else if (!/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(localData.email)) {
            errorMap['email'] = 'Invalid email format.';
        }
        if (localData.password.length < 1) {
            errorMap['password'] = 'A password is required.';
        }
        if (!isEmptyObject(errorMap)) {
            e.preventDefault();
            setErrors(errorMap);
        }
        else if (globalThis.dataLayer) {
            globalThis.dataLayer.push({
                event: 'signUp',
            });
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Container, null,
            React.createElement(Row, null,
                React.createElement(Col, null,
                    React.createElement(Header.h2, { style: { marginBottom: '12px' }, className: "flex justify-center lg:justify-start" }, "CREATE ACCOUNT"))),
            React.createElement(Row, null,
                React.createElement(Col, { style: { marginBottom: '12px' }, className: "flex flex-column items-center lg:items-start" },
                    React.createElement("div", { className: "flex-shrink w-max" }, "For new users & account activation"))),
            React.createElement(Row, null,
                React.createElement(Col, { style: { fontSize: '10px' } },
                    React.createElement(Paragraph, { style: { fontSize: '10px' } },
                        "REQUIRED ",
                        React.createElement("span", { style: { color: '#EF3A4C' } }, "*")))),
            React.createElement(Row, null,
                React.createElement(Col, null,
                    React.createElement(Input, { label: "First Name", placeholder: "First Name", value: localData.firstName, onChangeValue: handleChange('firstName'), name: "customer[first_name]", state: calculateFieldState('firstName'), errorMessage: getErrorMessage('firstName'), type: "text", required: true, mask: true, dataTest: 'new-firstName' }))),
            React.createElement(Row, null,
                React.createElement(Col, null,
                    React.createElement(Input, { label: "Last Name", placeholder: "Last Name", value: localData.lastName, onChangeValue: handleChange('lastName'), name: "customer[last_name]", state: calculateFieldState('lastName'), errorMessage: getErrorMessage('lastName'), type: "text", required: true, mask: true, dataTest: 'new-lastName' }))),
            React.createElement(Row, null,
                React.createElement(Col, null,
                    React.createElement(Input, { label: "Email", placeholder: "Email", value: localData.email, onChangeValue: handleChange('email'), name: "customer[email]", state: calculateFieldState('email'), errorMessage: getErrorMessage('email'), type: "email", required: true, mask: true, dataTest: 'new-email' }))),
            React.createElement(Row, null,
                React.createElement(Col, null,
                    React.createElement(Input, { label: "Password", placeholder: "Password", value: localData.password, onChangeValue: handleChange('password'), name: "customer[password]", state: calculateFieldState('password'), errorMessage: getErrorMessage('password'), type: "password", required: true, mask: true, dataTest: 'new-password' }))),
            React.createElement(Row, null,
                React.createElement(Col, { style: { marginBottom: '12px' } },
                    React.createElement(Checkbox, { label: "Subscribe to our newsletter!", name: "customer[accepts_marketing]", value: localData.willSubscribe.toString(), checked: localData.willSubscribe, onChangeValue: handleChange('willSubscribe'), dataTest: 'new-subscribe' }))),
            React.createElement(Row, null,
                React.createElement(Col, null,
                    React.createElement(StyledButton, { type: "submit", onClick: handleSave, style: {
                            fontSize: '16px',
                            fontWeight: 600,
                            height: '40px',
                            minHeight: '40px',
                        }, "data-test": "create-account-btn" }, "Create Account"))))));
};
CreateCustomerForm.defaultProps = {};
export default CreateCustomerForm;
